var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.125,
    height: 48.961,
    viewBox: "0 0 43.125 48.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    transform: "translate(-283.92 -5329.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(285.42 5345.582)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_426",
    "data-name": "Line 426",
    x2: 40.125,
    transform: "translate(0 31.348)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2552",
    "data-name": "Rectangle 2552",
    transform: "translate(28.907)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H8.2a2,2,0,0,1,2,2V31.766a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1.5H8.2a.5.5,0,0,1,.5.5V30.266a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V2A.5.5,0,0,1,2,1.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2553",
    "data-name": "Rectangle 2553",
    transform: "translate(15.532 12.539)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H8.2a2,2,0,0,1,2,2V19.227a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1.5H8.2a.5.5,0,0,1,.5.5V17.727a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V2A.5.5,0,0,1,2,1.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2554",
    "data-name": "Rectangle 2554",
    transform: "translate(2.157 19.227)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H8.2a2,2,0,0,1,2,2V12.539a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1.5H8.2a.5.5,0,0,1,.5.5v9.039a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V2A.5.5,0,0,1,2,1.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 1.528,
    cy: 1.528,
    r: 1.528,
    transform: "translate(285.802 5355.595)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311",
    transform: "translate(290.859 5331.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M-3971.074-1027.75l15.868-15.713,3.724,3.763,10.476-10.747",
    transform: "translate(3971.074 1050.524)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M-3942.67-1050.151l6.4-.388v6.44",
    transform: "translate(3966.414 1050.539)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfits);
export default __webpack_public_path__ + "static/media/Profits.394dc05c66a418c936f52bb02657b757.svg";
export { ForwardRef as ReactComponent };